import convertObjectToParams from '../lib/convertObjectToParams';
import config from './config';
import AppAccessToken from './appAccessToken';
import appVersion from '../jsVersion';
import { startedNetworkRequest, completedNetworkRequest } from '../redux/modules/network';

function buildHeaders({ httpMethod, accessToken }) {
  const userAgent = `${config.clientName} v${appVersion}`;

  const headers = {};
  headers['User-Agent'] = userAgent;
  headers['Accept'] = 'application/hal+json';
  if (httpMethod === 'POST' || httpMethod === 'PUT') {
    headers['Content-Type'] = 'application/json';
  }
  if (accessToken) {
    headers['Authorization'] = `Bearer ${accessToken}`;
  }

  return new Headers(headers);
}

function buildUrl({ host, path, queryParams = {} }) {
  let url = `${host}${path}`;

  if (Object.keys(queryParams).length > 0) {
    const queryString = convertObjectToParams(queryParams);
    url = `${url}?${queryString}`;
  }

  return url;
}

function buildRequest({ httpMethod, path, queryParams = {}, bodyParams = {} }) {
  return new Promise((resolve, reject) => {
    const url = buildUrl({ host: config.apiHost, path, queryParams });

    const accessToken = AppAccessToken.getAccessToken();

    if (accessToken) {
      const headers = buildHeaders({ httpMethod, accessToken });

      const requestOptions = {
        method: httpMethod,
        mode: 'cors',
        headers: headers
      };
      if (Object.keys(bodyParams).length > 0) {
        requestOptions.body = JSON.stringify(bodyParams);
      }

      resolve(new Request(url, requestOptions));
    } else {
      reject({ message: 'No access token to make request.' });
    }
  });
}

function sendRequest(request) {
  startedNetworkRequest();

  return fetch(request).then(response => {
    completedNetworkRequest();

    if (!response.ok) {
      const errorStatus = response.status || 520;
      const errorMessage = `Server Error: ${errorStatus}`;
      
      // const parsedResponse = response.json();
      // if (parsedResponse && parsedResponse.error) {
      //   errorMessage = parsedResponse.error;
      // }

      console.log(`http error (${errorStatus}): ${errorMessage}`);
      throw Error(errorMessage);
    } else {
      if (response.status === 204) {
        return Promise.resolve();
      } else {
        return response.json();
      }
    }
  }).catch(error => {
    completedNetworkRequest();
    throw Error(error);
  });
}

function makeRequest({ httpMethod, path, queryParams = {}, bodyParams = {} }) {
  return buildRequest({ httpMethod, path, queryParams, bodyParams }).then(sendRequest);
}

const HttpClient = {

  get(path, queryParams = {}) {
    return makeRequest({ httpMethod: 'GET', path, queryParams });
  },

  post(path, bodyParams = {}) {
    return makeRequest({ httpMethod: 'POST', path, bodyParams });
  },

  put(path, bodyParams = {}) {
    return makeRequest({ httpMethod: 'PUT', path, bodyParams });
  },

  destroy(path) {
    return makeRequest({ httpMethod: 'DELETE', path });
  }

};

export default HttpClient;



// WEBPACK FOOTER //
// ./src/api/httpClient.js